/* eslint-disable react/prop-types */

const StaticPageLayout = ({ title, subtitle, lastUpdated, children }) => {
  return (
    <div className="bg-slate-50 text-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="bg-white/80 backdrop-blur rounded-2xl border border-white shadow-sm p-6 sm:p-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#021133]">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-3 text-gray-700 leading-relaxed">{subtitle}</p>
          ) : null}
          {lastUpdated ? (
            <p className="mt-3 text-sm text-gray-500">
              Last updated: {lastUpdated}
            </p>
          ) : null}
        </div>

        <div className="mt-8 sm:mt-10 space-y-6">{children}</div>
      </div>
    </div>
  );
};

export default StaticPageLayout;


